import { ReactNode, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import clsx from 'clsx';

import { Portal } from 'shared/ui/portal';
import { MODAL_ANIMATION_DURATION } from 'shared/config/constants';
import { getAmpConfigFlags } from 'shared/config/amp-config';

import styles from './styles.module.scss';

export type NotificationPopupProps = {
  children: ReactNode;
  isVisible: boolean;
  handleClose: () => void;
  variant?: 'success' | 'error' | '';
};

export const NotificationPopup = ({
  children,
  isVisible,
  handleClose,
  variant = '',
}: NotificationPopupProps) => {
  const notificationPopupRef = useRef<HTMLDivElement>(null);

  const closeIconStyles = variant === 'success' ? { color: '#fff' } : {};

  const { isNewNavigationEnabled } = getAmpConfigFlags();

  return (
    <Portal>
      <CSSTransition
        nodeRef={notificationPopupRef}
        in={isVisible}
        timeout={MODAL_ANIMATION_DURATION}
        classNames="modal-fade"
        unmountOnExit
      >
        <div
          ref={notificationPopupRef}
          className={clsx(styles.notificationPopup, styles[variant], {
            [styles.notificationPopupWithNewNav]: isNewNavigationEnabled,
          })}
          aria-modal="true"
          role="alertdialog"
        >
          <div className={styles.popupContent}>{children}</div>
          <div className={styles.closeBtn}>
            <button
              onClick={handleClose}
              className="btn btn-icon-ghost"
              aria-label="Close"
            >
              <i
                className="icon-v2-close"
                style={closeIconStyles}
                aria-hidden
              />
            </button>
          </div>
        </div>
      </CSSTransition>
    </Portal>
  );
};
